// extracted by mini-css-extract-plugin
module.exports = {"wrapperTree":"index_wrapperTree__2rV8V","scrollStyle":"index_scrollStyle__1S_RX","styleMenu":"index_styleMenu__1WJIK","searchInput":"index_searchInput__2AXVw"};